/* file description */
import { useEffect } from 'react';
import type { UseSendInitData } from './type';

export const useSendInitData: UseSendInitData = ({
  formInitData,
  onLoad,
}) => {
  useEffect(() => {
    if (formInitData?.isRender && onLoad) {
      const value = formInitData?.value;
      onLoad({ ...value });
    }
  }, [formInitData]);
};

